import { cn } from '@qr-front/ui/utils'

import { CheckIcon } from './CheckIcon'
import { TStepProps } from './types'

export const BaseStep = ({
	index,
	state,
	labelMobile,
	labelDesktop,
	hideLabel,
}: TStepProps) => {
	const label = (
		<p
			className={cn(
				labelMobile ? '' : 'hidden',
				labelDesktop ? 'tablet:inline' : 'tablet:hidden',
				'type-body-small',
				state === 'current' && 'text-black transition-colors',
			)}
		>
			<span className="tablet:hidden">{labelMobile}</span>
			<span className="hidden tablet:inline">{labelDesktop}</span>
		</p>
	)

	return (
		<div className="flex items-center gap-1 whitespace-nowrap desktop:gap-2">
			<div
				className={cn(
					'type-body-caption flex h-6 w-7 items-center justify-center rounded-full border border-border-grey transition-colors tablet:type-body-small desktop:size-7',
					state === 'current' && 'border-none bg-blue text-white',
				)}
			>
				{state === 'completed' ? (
					<CheckIcon className="size-3" />
				) : (
					index + 1
				)}
			</div>
			{!hideLabel ? label : null}
		</div>
	)
}
